module.exports = __webpack_public_path__ + "img/Ora-Ani_Felseinschnitt_kl.422d57cc.jpg";